// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"5ee65116","147":"e1139760","295":"d46cc444","362":"6ff7a932","574":"a1d5d423","807":"5a93c69c","818":"ea733b9f","899":"8ffc2c70","900":"8e07878c","996":"126a654c"}[chunkId] + ".chunk.js";
};